
import { ISitesAndTenantsInfo } from '~src/siteManagement/serverApi/types/ISitesAndTenantsInfo';

export function getTenantIdforCurrentSite(sitesAndTentantsInfo: ISitesAndTenantsInfo, siteLuid: string): string {
    if(sitesAndTentantsInfo === undefined || sitesAndTentantsInfo.sitesInfo.length === 0) return '';
    else{
      let tenant = sitesAndTentantsInfo.sitesInfo.find(site => site.id === siteLuid);
      return tenant === undefined ? '' : tenant.parentTenant.id;
    }
  }